"use strict";
/**
 * Get image URL from image key.
 * @function getTransformationUrl
 * @param {string} imageKey - imageKey.
 * @param {string} location - location.
 * @param {string} browser - browser.
 * @param {number} version - version.
 * @return {string} image URL.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransformationUrl = void 0;
// thumbnail desktop v2 -- for productboxes
// just the imagekey -- works for the rest (full size)
exports.getTransformationUrl = function (imageKey, location, browser, version) {
    if (imageKey === void 0) { imageKey = 'default'; }
    if (location === void 0) { location = 'pdp'; }
    if (browser === void 0) { browser = 'desktop'; }
    if (version === void 0) { version = 1; }
    var transformationType = browser + "-" + location + "-v" + version;
    return "https://a.nooncdn.com/t_" + transformationType + "/" + imageKey + ".jpg";
};
//# sourceMappingURL=image.js.map